<template>
  <div class="table-wrapper insurance-list-print">
    <div class="insurance-list-print__sheet">
      <div class="table-scroll-x insurance-list-table-scroll-x">
        <div class="insurance-list-main-tables">
          <table class="table-header">
            <thead>
              <tr class="title-row">
                <th colspan="12">
                  <div class="table-title">
                    <div class="main-title">{{ workshopName || "-" }}</div>
                    <div>
                      {{ $t("insurance_list_tammin") }} {{ salaryMonth }}-{{ salaryYear }}
                    </div>
                    <div>{{ $t("tammin_organization_branch") }}</div>
                    <div>{{ $t("workshopCode") }}: {{ workshopCode || "-" }}</div>
                  </div>
                </th>
              </tr>

              <tr>
                <th>{{ $t("row") }}</th>
                <th>{{ $t("fathersName") }}</th>
                <th>{{ $t("employeeCode") }}</th>
                <th>{{ $t("Role") }}</th>
                <th>{{ $t("startToWork") }}</th>
                <th>{{ $t("nationality") }}</th>
                <th>{{ $t("performance_") }}</th>
                <th>{{ $t("DailyWage") }}</th>
                <th>{{ $t("employer’s_insurance") }}</th>
                <th>{{ $t("Total_benefits&salary") }}</th>
                <th>{{ $t("other") }}{{ $t("deductions") }}</th>
                <th rowspan="2">{{ $t("signature") }}<br />{{ $t("AccountNumber") }}</th>
              </tr>
              <tr>
                <th>{{ $t("name_and_lastName") }}</th>
                <th>{{ $t("Birth Certificate Number") }}</th>
                <th>{{ $t("national-code") }}</th>
                <th>{{ $t("RoleCode") }}</th>
                <th>{{ $t("EndToWork") }}</th>
                <th>{{ $t("gender") }}</th>
                <th>{{ $t("InsurerNumber") }}</th>
                <th>{{ $t("MonthlyWage") }}</th>
                <th>{{ $t("Employee’s share of insurance") }}</th>
                <th>{{ $t("covered_benefits") }}</th>
                <th>{{ $t("netPay") }}</th>
              </tr>
            </thead>
          </table>
          <div class="scroll-body insurance-list-print__data-scroll">
            <table class="insurance-list-print__data-table">
              <tbody>
                <template v-for="(row, index) in rows">
                  <tr :key="'top' + index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ cellDisplay(row.father) }}</td>
                    <td>{{ cellDisplay(row.employeeCode) }}</td>
                    <td>{{ cellDisplay(row.job) }}</td>
                    <td>{{ cellDisplay(row.startWork) }}</td>
                    <td>{{ cellDisplay(row.nationality) }}</td>
                    <td>{{ cellDisplay(row.workDays) }}</td>
                    <td>{{ cellDisplay(row.dailySalary) }}</td>
                    <td>{{ cellDisplay(row.insuranceBase) }}</td>
                    <td>{{ cellDisplay(row.total_Benefit_wage) }}</td>
                    <td>{{ cellDisplay(row.deductions) }}</td>
                    <td rowspan="2">{{ cellDisplay(row.signature) }}</td>
                  </tr>

                  <tr :key="'bottom' + index" class="sub-row">
                    <td>{{ cellDisplay(row.name) }}</td>
                    <td>{{ cellDisplay(row.birth_certificate_number) }}</td>
                    <td>{{ cellDisplay(row.national_code) }}</td>
                    <td>{{ cellDisplay(row.jobCode) }}</td>
                    <td>{{ cellDisplay(row.leaveWork) }}</td>
                    <td>{{ genderCell(row.gender) }}</td>
                    <td>{{ cellDisplay(row.insuranceNumber) }}</td>
                    <td>{{ cellDisplay(row.monthSalary) }}</td>
                    <td>{{ cellDisplay(row.employeeInsurance) }}</td>
                    <td>{{ cellDisplay(row.coverd_Benefit) }}</td>
                    <td>{{ cellDisplay(row.purePey) }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <table class="table-footer insurance-list-print__footer-table">
            <tfoot>
              <tr class="sum-row">
                <!-- <td rowspan="2"></td> -->
                <td colspan="7" rowspan="2" class="sum-title">{{ $t("sum") }}</td>
                <td>{{ totalBaseSalaryDailyRaw }}</td>
                <td>{{ totalComponyInsurance }}</td>
                <td>{{ totalBenefitWage }}</td>
                <td>{{ totaldeductions }}</td>
                <td rowspan="2"></td>
              </tr>
              <tr class="sum-row">
                <td>{{ totalBaseSalaryRaw }}</td>
                <td>{{ totalEmployeeInsurance }}</td>
                <td>{{ totalBenefitWageCoverd }}</td>
                <td>{{ totalPurePey }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <v-container class="pa-0 ma-0 mt-5 insurance-container">
        <!-- LEFT TABLE -->
        <table class="table right-table">
          <tr>
            <th colspan="2">{{ $t("count_persons") }}</th>
            <th rowspan="5" class="signature-cell">
              {{ $t("employer’s Stamp and Signature") }}
            </th>
          </tr>
          <tr>
            <td class="value">0</td>
            <td class="label">{{ $t("Iranian") }}</td>
          </tr>
          <tr>
            <td class="value">0</td>
            <td class="label">{{ $t("Non‑Iranian") }}</td>
          </tr>
          <tr>
            <td class="value">1</td>
            <td class="label">{{ $t("Man") }}</td>
          </tr>
          <tr>
            <td class="value">1</td>
            <td class="label">{{ $t("Woman") }}</td>
          </tr>
        </table>
        <table class="table left-table">
          <tr>
            <td class="label">{{ $t("total_employee_insurance_contribution") }}</td>
            <td class="value">{{ totalEmployeeInsurance }}</td>
          </tr>
          <tr>
            <td class="label">{{ $t("total_employer_insurance_contribution") }}</td>
            <td class="value">{{ totalComponyInsurance }}</td>
          </tr>
          <tr>
            <td class="label">{{ $t("total_unemployment_insurance_contribution") }}</td>
            <td class="value">{{ totalJoblessInsurance }}</td>
          </tr>
          <tr>
            <td class="label">{{ $t("total_insurance_contribution_for_hard_Jobs") }}</td>
            <td class="value">0</td>
          </tr>
          <tr>
            <td class="label bold">{{ $t("sum-total") }}</td>
            <td class="value bold">{{ totalInsuranceThreeSum }}</td>
          </tr>
        </table>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rows: [],
    };
  },
  beforeMount() {
    this.getItems();
  },
  beforeDestroy() {
    document.body.classList.remove("documents-print-insurance-only");
    if (this._insurancePrintMqCleanup) {
      this._insurancePrintMqCleanup();
      this._insurancePrintMqCleanup = null;
    }
  },
  computed: {
    totalEmployeeInsurance() {
      const total = this.rows.reduce((sum, row) => {
        return sum + Number(row.employeeInsuranceRaw || 0);
      }, 0);
      return total.toLocaleString();
    },
    totalComponyInsurance() {
      const total = this.rows.reduce((sum, row) => {
        return sum + Number(row.companyInsuranceRaw || 0);
      }, 0);
      return total.toLocaleString();
    },
    totalJoblessInsurance() {
      const total = this.rows.reduce((sum, row) => {
        return sum + Number(row.joblessInsuranceRaw || 0);
      }, 0);
      return total.toLocaleString();
    },
    totalInsuranceThreeSum() {
      const total = this.rows.reduce((sum, row) => {
        return (
          sum +
          Number(row.employeeInsuranceRaw || 0) +
          Number(row.companyInsuranceRaw || 0) +
          Number(row.joblessInsuranceRaw || 0)
        );
      }, 0);
      return total.toLocaleString();
    },
    totalBenefitWage() {
      const total = this.rows.reduce((sum, row) => {
        return sum + Number(row.benefitRaw || 0);
      }, 0);
      return total.toLocaleString();
    },
    totalBenefitWageCoverd() {
      const total = this.rows.reduce((sum, row) => {
        return sum + Number(row.coverdBenefitRaw || 0);
      }, 0);
      return total.toLocaleString();
    },
    totaldeductions() {
      const total = this.rows.reduce((sum, row) => {
        return sum + Number(row.deductionsRaw || 0);
      }, 0);
      return total.toLocaleString();
    },
    totalPurePey() {
      const total = this.rows.reduce((sum, row) => {
        return sum + Number(row.purePeyRaw || 0);
      }, 0);
      return total.toLocaleString();
    },
    totalBaseSalaryDailyRaw() {
      const total = this.rows.reduce((sum, row) => {
        return sum + Number(row.baseSalaryDailyRaw || 0);
      }, 0);
      return total.toLocaleString();
    },
    totalBaseSalaryRaw() {
      const total = this.rows.reduce((sum, row) => {
        return sum + Number(row.baseSalaryRaw || 0);
      }, 0);
      return total.toLocaleString();
    },
  },
  methods: {
    cellDisplay(val) {
      if (val === null || val === undefined) return "-";
      if (typeof val === "number" && Number.isNaN(val)) return "-";
      if (typeof val === "string" && val.trim() === "") return "-";
      return val;
    },
    genderCell(gender) {
      if (
        gender === null ||
        gender === undefined ||
        (typeof gender === "string" && gender.trim() === "")
      ) {
        return "-";
      }
      return this.$t(gender);
    },
    sumField(field) {
      const total = this.rows.reduce((s, r) => s + Number(r[field] || 0), 0);
      return total.toLocaleString();
    },
    /** Opens the browser print dialog; only `.insurance-list-print` stays visible (see global @media print). */
    printReport() {
      document.body.classList.add("documents-print-insurance-only");
      const cleanup = () => {
        document.body.classList.remove("documents-print-insurance-only");
        window.removeEventListener("afterprint", onAfterPrint);
        if (this._insurancePrintMqCleanup) {
          this._insurancePrintMqCleanup();
          this._insurancePrintMqCleanup = null;
        }
      };
      const onAfterPrint = () => cleanup();
      window.addEventListener("afterprint", onAfterPrint);
      const mql = window.matchMedia("print");
      const onMq = (e) => {
        if (!e.matches) cleanup();
      };
      if (mql.addEventListener) {
        mql.addEventListener("change", onMq);
        this._insurancePrintMqCleanup = () => mql.removeEventListener("change", onMq);
      } else {
        mql.addListener(onMq);
        this._insurancePrintMqCleanup = () => mql.removeListener(onMq);
      }
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            window.print();
          });
        });
      });
    },
    getItems() {
      var app = this;
      const id_ = app.$route.query.id;
      app.$axios
        .get(app.$endpoint + "salary/employee-list/" + id_)
        .then((response) => {
          const salaries = response.data.salaries.data || [];
          // add workshop data
          const workshopData = response.data.workshop || {};
          this.workshopName = workshopData.workshop?.name || "";
          this.salaryYear = workshopData.year || "";
          this.salaryMonth = workshopData.month || "";
          this.workshopCode = workshopData.workshop?.insurance_code || "";
          //
          this.rows = salaries.map((item) => {
            const emp = item.employee || {};
            const employeeInsuranceRaw = Number(item.employee_insurance || 0);
            const companyInsuranceRaw = Number(item.company_insurance || 0);
            const joblessInsuranceRaw = Number(item.jobless_insurance || 0);
            const benefitRaw = Number(item.benefit || 0);
            const taxRaw = Number(item.tax || 0);
            const deductionsRaw = Number(item.deductions || 0);
            const coverdBenefitRaw = Number(item.applicable_insurance_value || 0);
            const purePeyRaw = Number(benefitRaw - taxRaw - deductionsRaw);
            const baseSalaryDailyRaw = Number(item.base_salary_daily || 0);
            const baseSalaryRaw = Number(item.base_salary || 0);
            return {
              name: emp?.user?.name || "",
              father: emp?.fathers_name || "",
              birth_certificate_number: emp?.birth_certificate_number || "",
              national_code: emp?.user?.national_code || "",
              employeeCode: emp.personnel_code || "",
              melli: emp.national_code || "",
              job: emp.finance_job_position || "",
              jobCode: emp.finance_job_code || "",
              startWork: emp.start_to_work || "",
              leaveWork: emp.end_to_work || "",
              nationality: emp.nationality || "",
              gender: emp?.user?.gender || "",
              workDays: item.daily_work,
              insuranceNumber: emp.insurer_number || "",
              employeeInsuranceRaw,
              companyInsuranceRaw,
              joblessInsuranceRaw,
              benefitRaw,
              purePeyRaw,
              taxRaw,
              deductionsRaw,
              coverdBenefitRaw,
              baseSalaryDailyRaw,
              baseSalaryRaw,
              dailySalary: this.$numberFormat(item.base_salary_daily) || "",
              monthSalary: this.$numberFormat(item.base_salary) || "",
              insuranceBase: this.$numberFormat(item.company_insurance) || "",
              employeeInsurance: this.$numberFormat(item.employee_insurance) || "",
              total_Benefit_wage: this.$numberFormat(item.benefit) || "",
              coverd_Benefit: this.$numberFormat(item.applicable_insurance_value) || "",
              deductions: this.$numberFormat(item.deductions) || "",
              purePey:
                this.$numberFormat(item.benefit - item.tax - item.deductions) || "",
              signature: "",
            };
          });
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.$emit("initial-Loading-is", false);
          app.$emit("call-refresh");
        });
    },
  },
};
</script>

<style scoped>
.signature-cell {
  width: 240px;
  vertical-align: middle;
  text-align: center;
  font-weight: bold;
}
.table-wrapper {
  direction: rtl;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  padding: 0px;
  background: #fff;
}

.insurance-list-print__sheet {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.insurance-list-table-scroll-x.table-scroll-x {
  width: 100%;
  max-width: 100%;
  align-self: stretch;
}
.insurance-list-main-tables {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
}
@media (max-width: 1120px) {
  .insurance-list-table-scroll-x.table-scroll-x {
    overflow-x: auto;
  }
  .insurance-list-main-tables {
    min-width: 1120px;
  }
}
@media (max-height: 850px) {
  .insurance-list-table-scroll-x.table-scroll-x {
    overflow-x: auto;
  }
  .insurance-list-main-tables {
    min-width: 1120px;
  }
}
table {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
  border-bottom: 1px solid #666;
}
.table-title {
  text-align: center;
  margin-bottom: 0px;
  line-height: 1.4;
  background: #efefef;
}
.scroll-body {
  border-top: none;
  overflow-y: visible;
}
.scroll-body tbody tr td:first-child {
  padding: 2px !important;
}
.scroll-body table {
  border-collapse: collapse;
  border-bottom: 1px solid #666;
}
.table-title {
  text-align: center;
  line-height: 1.4;
  background: #efefef;
  padding: 0px 0;
}
.title-row th {
  padding: 0;
  border-bottom: none;
  background: #efefef;
  font-size: 12px;
}
th {
  background: #efefef;
  padding: 6px;
}
tr {
  padding: 6px;
}
th,
td {
  border: 1px solid #444;
  text-align: center;
  padding: 3px;
  font-size: 11px;
}

.insurance-list-print
  .insurance-list-print__data-scroll
  table.insurance-list-print__data-table
  tbody
  td {
  font-size: 11px !important;
}
.insurance-list-print table.insurance-list-print__footer-table tfoot td {
  font-size: 11px !important;
}

.insurance-list-print ::v-deep table.insurance-list-print__data-table tbody td {
  font-size: 11px !important;
}
.insurance-list-print ::v-deep table.insurance-list-print__footer-table tfoot td {
  font-size: 11px !important;
}

thead tr:first-child th {
  background: #efefef;
}
thead tr:nth-child(2) th {
  background: #efefef;
}
.sub-row td {
  border-top: 1px dotted #777;
}

tfoot td {
  background: #f2f2f2;
  font-weight: bold;
  text-align: center;
}
.sum-title {
  text-align: center;
}
.insurance-list-print table.insurance-list-print__footer-table tfoot td.sum-title {
  font-size: 11px !important;
}
.sum-row td {
  border-top: 2px solid #444;
}
.table-header,
.table-footer,
.scroll-body table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.right-table td,
.right-table th,
.left-table td,
.left-table th {
  font-size: 10px;
  line-height: 1.25;
  vertical-align: middle;
  box-sizing: border-box;
}

.right-table > tr:first-child th {
  min-height: 34px;
  padding: 10px 4px;
}
.insurance-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.insurance-container .right-table,
.insurance-container .left-table {
  flex: 1 1 calc(50% - 6px);
  width: calc(50% - 6px);
  max-width: calc(50% - 6px);
  min-width: 0;
  box-sizing: border-box;
}

@media (max-width: 800px) {
  .insurance-container {
    flex-direction: column;
  }
  .insurance-container .right-table,
  .insurance-container .left-table {
    flex: 1 1 auto;
    width: 100%;
    max-width: 100%;
  }
  .right-table th {
    height: 35px;
  }
}
.right-table td,
.left-table td {
  padding: 1px 4px;
  height: 12px;
}
.right-table,
.left-table {
  border-collapse: collapse;
}
</style>

<style>
@media print {
  @page {
    size: A4 landscape;
    margin: 8mm 10mm;
  }

  html,
  body {
    width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  body.documents-print-insurance-only * {
    visibility: hidden;
  }
  body.documents-print-insurance-only .insurance-list-print,
  body.documents-print-insurance-only .insurance-list-print * {
    visibility: visible;
  }
  body.documents-print-insurance-only .insurance-list-print {
    position: fixed !important;
    left: 0 !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100vw !important;
    min-height: 100vh !important;
    max-width: 100vw !important;
    margin: 0 !important;
    padding: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: flex-start !important;
    z-index: 2147483647 !important;
    background: #fff !important;
    box-sizing: border-box !important;
    overflow: visible !important;
    direction: rtl !important;
  }

  body.documents-print-insurance-only .insurance-list-print__sheet {
    width: 100% !important;
    max-width: 277mm !important;
    margin: 0 auto !important;
    padding: 2mm 4mm !important;
    box-sizing: border-box !important;
    flex: 0 0 auto;
    overflow: visible !important;
  }

  body.documents-print-insurance-only .insurance-list-print__data-scroll {
    max-height: none !important;
    overflow: visible !important;
  }
  body.documents-print-insurance-only .insurance-list-table-scroll-x {
    overflow: visible !important;
    max-width: 100% !important;
    width: 100% !important;
  }
  body.documents-print-insurance-only .insurance-list-main-tables {
    min-width: 0 !important;
    width: 100% !important;
  }

  body.documents-print-insurance-only .insurance-list-print .table-header,
  body.documents-print-insurance-only
    .insurance-list-print
    .insurance-list-print__data-table,
  body.documents-print-insurance-only .insurance-list-print .table-footer {
    width: 100% !important;
    max-width: 100% !important;
    table-layout: fixed !important;
    border-collapse: collapse !important;
    page-break-inside: auto;
  }

  body.documents-print-insurance-only .insurance-list-print th,
  body.documents-print-insurance-only .insurance-list-print td {
    font-size: 7.5pt !important;
    line-height: 1.2 !important;
    padding: 2px 2px !important;
    word-wrap: break-word;
    overflow-wrap: anywhere;
    vertical-align: middle !important;
    border: 1px solid #000 !important;
  }

  body.documents-print-insurance-only .insurance-list-print th {
    background: #eee !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  body.documents-print-insurance-only .insurance-list-print tfoot td {
    background: #f2f2f2 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  body.documents-print-insurance-only .insurance-list-print .table-title {
    background: #eee !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  body.documents-print-insurance-only .insurance-list-print .insurance-container {
    display: flex !important;
    flex-direction: row !important;
    width: 100% !important;
    max-width: 100% !important;
    justify-content: space-between !important;
    align-items: flex-start !important;
    flex-wrap: nowrap !important;
    gap: 10px !important;
    page-break-inside: avoid;
    margin-top: 6px !important;
    box-sizing: border-box !important;
  }

  body.documents-print-insurance-only
    .insurance-list-print
    .insurance-container
    .right-table,
  body.documents-print-insurance-only
    .insurance-list-print
    .insurance-container
    .left-table {
    flex: 1 1 calc(50% - 5px) !important;
    width: calc(50% - 5px) !important;
    max-width: calc(50% - 5px) !important;
    min-width: 0 !important;
    table-layout: fixed !important;
    border-collapse: collapse !important;
    box-sizing: border-box !important;
  }

  body.documents-print-insurance-only .insurance-list-print .v-container {
    max-width: 100% !important;
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  body.documents-print-insurance-only .insurance-list-print .signature-cell {
    width: 22mm !important;
    min-width: 22mm !important;
  }
}
</style>
